/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Sync_Phase_Embedding_CountInputs */



/**
* | output |
* | --- |
* | "Embedding {count} files..." |
*
* @param {Sync_Phase_Embedding_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_embedding_count = /** @type {((inputs: Sync_Phase_Embedding_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_Embedding_CountInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Einbettung von ${i?.count} Dateien...`)
	return /** @type {LocalizedString} */ (`Embedding ${i?.count} files...`)
});